const MS_PER_SECOND = 1000;
const MS_PER_DAY = 1000 * 60 * 60 * 24;

export function formatDayDate(date: Date) {
  return date.toLocaleDateString('es-ES', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
}

export function formatDayDateWithHour(date: Date) {
  return date.toLocaleDateString('es-ES', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
  });
}

export function formatSortDate(date: Date) {
  return date.toLocaleDateString('es-ES', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  });
}

/** Splits a duration in seconds into `[hours, minutes, seconds]`. */
export function formatFromSeconds(secs: number) {
  return [
    Math.floor(secs / 3600),
    Math.floor(secs / 60) % 60,
    Math.floor(secs % 60),
  ];
}

/** A duration in seconds as `mm:ss`, growing to `hh:mm:ss` past an hour. */
export function formatTimestamp(timestamp: number) {
  return formatFromSeconds(timestamp)
    .map((value) => (value < 10 ? '0' + value : value))
    .filter((value, index) => value !== '00' || index > 0)
    .join(':');
}

/** Whole calendar days between two dates, ignoring the time of day. */
export function dateDiffInDays(a: Date, b: Date) {
  const utcA = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
  const utcB = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());

  return Math.floor((utcB - utcA) / MS_PER_DAY);
}

/**
 * A reading of a clock that only ever moves forward, so the device clock being changed —
 * by an NTP sync, a timezone fix or the user — cannot shorten or lengthen a countdown.
 * Only differences between two readings mean anything; the origin is arbitrary.
 */
export function monotonicNow() {
  return typeof performance === 'undefined' ? Date.now() : performance.now();
}

/** The monotonic reading a countdown of `seconds` starting now runs out at. */
export function monotonicDeadline(seconds: number) {
  return monotonicNow() + seconds * MS_PER_SECOND;
}

/**
 * Whole seconds left until a monotonic deadline, rounded up so the last second is shown
 * as `1` and `0` is reached exactly when the time is up, and negative once it has passed.
 */
export function secondsUntilDeadline(deadline: number) {
  return Math.ceil((deadline - monotonicNow()) / MS_PER_SECOND);
}

export function getUTCTimezoneOffset(date: Date) {
  const currentTimezone = date.getTimezoneOffset();
  const { hours, minutes } = toHoursAndMinutes(currentTimezone * -1);

  let gmt = 'UTC';
  gmt += currentTimezone === 0 ? ' ' : currentTimezone > 0 ? ' -' : ' +';
  gmt += `${hours < 10 ? '0' : ''}${hours}:${
    minutes < 10 ? '0' : ''
  }${minutes}`;

  return gmt;
}

function toHoursAndMinutes(totalMinutes: number) {
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;

  return { hours, minutes };
}
